export const getChildOptions = (options, parentValue) => {
  // Require a non-nullish parent_id so options without one are never treated
  // as children of a parent whose value is also nullish (would self-recurse).
  return options.filter(
    (option) =>
      option.parent_id !== undefined &&
      option.parent_id !== null &&
      option.parent_id === parentValue
  );
};

export const getAllDescendants = (options, parentValue) => {
  let descendants = [];
  const children = getChildOptions(options, parentValue);

  children.forEach((child) => {
    descendants.push(child);
    descendants = [...descendants, ...getAllDescendants(options, child.value)];
  });

  return descendants;
};

export const getRootOptions = (options) => {
  return options.filter(
    (option) => option.parent_id === undefined || option.parent_id === null
  );
};
